import styled from "styled-components";
import { Button, Spacer, TagOrBadge } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../../i18n/i18n";
import { UploadSupportingDocumentButton } from "./uploadSupportingDocumentButton";
import { AxiosProgressEvent } from "axios";
import { colors } from "@qivia/ui/src/styles/figmaColors";

export interface UploadSupportingDocumentMenuOptionsProps {
  isPendingAdjustment: boolean;
  transactionId: string;
  setUploadEventInfo: (ape: AxiosProgressEvent) => void;
}
export const UploadSupportingDocumentMenuOptions = (
  props: UploadSupportingDocumentMenuOptionsProps,
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isPendingAdjustment, transactionId, setUploadEventInfo } = props;

  return (
    <StyledContainer>
      <UploadSupportingDocumentButton
        transactionId={transactionId}
        setUploadEventInfo={setUploadEventInfo}
      >
        <TagOrBadge
          type="TAG"
          text={t("supportingDocument.photoTip") || ""}
          backgroundColor={
            colors["colors/system/informative/informative_ultraLight"]
          }
          textColor={colors["colors/system/informative/informative_normal"]}
        />
        <Spacer y={1} />
        <Button title={t("supportingDocument.add") || ""} height={3.5} />
      </UploadSupportingDocumentButton>
      {!isPendingAdjustment && (
        <Button
          title={t("supportingDocument.empty") || ""}
          onClick={() =>
            navigate(`/no_supporting_document?id=${transactionId}`)
          }
          withoutBackground
          height={3.5}
          underline
        />
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  width: 100%;
`;
